import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { transactionsRecurringEdit_template } from "../components/templates/transactionsRecurringEdit_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;
declare var Dropzone: any;

export class transactions_recurring_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: transactionsRecurringEdit_template;
    protected validationsList: validationsList_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){
        return "transactions_recurring_edit";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the transactions form
        this.editForm = new transactionsRecurringEdit_template("editForm", this.viewModel, this);

        return [this.validationsList.build(), this.editForm.build()];
    }

    fillPage() : void{
        this.getFormData();
    }

    protected saveEditTransaction(){

        this.save();
    }
    public cancelForm() {
        this.cancelEditTransaction();
    }

    protected cancelEditTransaction(){

        this.releaseLock();

        // redirect ot user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Transaction action canceled!");
        page.redirect('/payment/transactions/recurring/list/');
    }

    protected releaseLock(){

        // request a lock release
        let usrReq_url: string = '/api/payment/transaction/recurring/release/lock_edit';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.getVnAppZone().app.params.id] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    //
    // obtain the dynamic data required to fill the form
    protected getFormData(){

        this.loadingIn(this.editForm.builtTemplate);

        let id: number;
        let action: string;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["editForm"].id(id);
        }

        let usrReq_url: string = '/api/payment/transaction/recurring/data/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.viewModel["editForm"])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }
    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let thisModule = (<transactions_recurring_edit>obj);
                let responseParsed = JSON.parse(req.request.response);

                let vnApp = thisModule.getVnAppZone().app;
                let data = responseParsed.data;
                let trx = data.transaction;
                //let reverseTrx = data.reverseTransaction;


                obj.editForm.setCreationTypes(data.creationTypes);
                obj.editForm.setActionTypes(data.actionTypes);
                obj.editForm.setItemTypes(data.itemTypes);
                obj.editForm.setTypes(data.types);
                //Autofilter since we have only one itemType
                obj.editForm.setEntryTypes(data.entryTypes.filter(et => data.recurringItemTypesRules[data.itemTypes.id].includes(et.id)));
                obj.editForm.setAccounts(data.accounts);
                obj.editForm.setAllBrands(data.brands);
                obj.editForm.setBrandOptions(data.brands);
                obj.editForm.setCurrencies(data.currencies);
                obj.editForm.setRoles(data.roles);
                obj.editForm.setRecurringItemTypesRules(data.recurringItemTypesRules);

                if(trx.id){
                    obj.editForm.setSelectedUser(data.user);

                    obj.editForm.setSelectedRole(trx.idRole);
                    obj.editForm.setSelectedActionType(trx.idActionType);
                    obj.editForm.setSelectedType(trx.idType);
                    obj.editForm.setSelectedEntryType(trx.idEntryType);
                    obj.editForm.setSelectedItemType(trx.idItemType);
                    obj.editForm.setSelectedAccount(trx.idAccount);
                    obj.editForm.setSelectedCurrency(trx.idCurrency);
                    obj.editForm.setSelectedFrequency(trx.schedulingRule);
                    obj.editForm.setSelectedItem(trx.idItem);
                    obj.editForm.getTemplateViewModel().amount(trx.amount);
                    obj.editForm.getTemplateViewModel().note(trx.note);
                    obj.editForm.setValnetSupportSplit(trx.valnetSupportSplit);

                    if(data.user.idCompany == 2){
                        obj.editForm.showValnetSupportSplit(false)
                        obj.editForm.setValnetSupportSplit(false);
                    }
                    obj.editForm.limitBrandByCompany(data.user)


                    // obj.editForm.setSelectedBrands(data.selectedBrands);
                }
                else{

                    obj.editForm.setInfoTitle("Add ");
                    obj.editForm.setSelectedActionType(1);
                    //obj.editForm.setSelectedCreationType(1);
                    obj.editForm.setSelectedType(2);
                }

                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected getUsersSuggestion(keyword) {

        let subViewModel = {list: {keyword: keyword}, from: 'transactions_recurring'};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function(){
            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.users) {
                    obj.editForm.setUsers(responseParsed.data.users);
                }
            });
            obj.editForm.deactivateLoading();
        }
    }


    protected save(){

        let _this = this;
        let formReq_url: string = '/api/payment/transaction/recurring/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        subViewModel["editForm"].options_status = null;
        subViewModel["editForm"].options_currencies = null;
        subViewModel["editForm"].options_actionTypes = null;
        subViewModel["editForm"].options_creationTypes = null;
        subViewModel["editForm"].options_entryTypes = null;
        subViewModel["editForm"].users = null;

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveReturn;
        this.XHRHdl.execute();

    }

    protected onSaveReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let accountsEditModule = (<transactions_recurring_edit>obj);
                let responseParsed = JSON.parse(req.request.response);

                obj.releaseLock();

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Recurring Transaction saved successfully!");
                obj.validationsList.clearMessages();

                page.redirect('/payment/transactions/recurring/list/');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/transactions_recurring_edit.ts